<template>
  <td>
    {{ $e("Temps de réponse")}} :
  </td>
  <td>
    <template v-if="config?.dock?.id">
      <div class="flex items-center px-1 overflow-hidden" :class="DockLastPingBG">
        <svg class="w-[18px] mr-2 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.519 11.901">
          <g transform="translate(0 0)">
            <path
              d="M-2.156-2.733c.012-.125.018-.251.018-.375A3.95,3.95,0,0,0-6.083-7.053h-.2a3.912,3.912,0,0,0-2.61.987,3.441,3.441,0,0,0-1.528-.359,3.439,3.439,0,0,0-3.43,3.066A3,3,0,0,0-15.755-.578a2.988,2.988,0,0,0,2.984,2.984h.569a.376.376,0,0,0,.376-.376.376.376,0,0,0-.376-.376h-.568A2.235,2.235,0,0,1-15-.578a2.241,2.241,0,0,1,1.616-2.144.376.376,0,0,0,.272-.348,2.69,2.69,0,0,1,2.7-2.6,2.694,2.694,0,0,1,1.394.391.376.376,0,0,0,.463-.059A3.171,3.171,0,0,1-6.279-6.3h.2A3.2,3.2,0,0,1-2.89-3.108a3.192,3.192,0,0,1-.035.469.376.376,0,0,0,.131.345A2.227,2.227,0,0,1-1.988-.578,2.235,2.235,0,0,1-4.22,1.654h-.569a.376.376,0,0,0-.376.376.376.376,0,0,0,.376.376h.569A2.988,2.988,0,0,0-1.236-.578,2.977,2.977,0,0,0-2.156-2.733Z"
              transform="translate(15.755 7.053)" />
            <path
              d="M14.97,39.336a.376.376,0,0,0,.071-.527l-1.286-1.686-.008-.008L13.73,37.1l-.019-.019-.019-.017-.008-.008-.009-.005-.021-.014-.024-.014-.019-.01L13.588,37l-.025-.009-.023-.006-.022,0-.026,0-.026,0h-.021l-.026,0-.026,0-.022,0-.023.006L13.323,37l-.023.009-.019.01-.024.014-.022.014-.009.005-.008.008-.019.016-.019.019-.017.02-.008.008L11.87,38.809a.376.376,0,0,0,.6.456l.611-.8v3.412a.376.376,0,1,0,.752,0V38.464l.611.8a.376.376,0,0,0,.527.071Z"
              transform="translate(-7.649 -30.352)" />
            <path
              d="M34.283,39.892a.376.376,0,0,0-.527.071l-.611.8V37.352a.376.376,0,0,0-.752,0v3.412l-.611-.8a.376.376,0,1,0-.6.456l1.287,1.686.007.007.017.02c.008.009.017.017.027.025l.016.014,0,0,.01.006.023.015.027.016.012.005.022.009.04.013.014,0,.012,0a.391.391,0,0,0,.069.007h0a.391.391,0,0,0,.069-.007l.012,0,.014,0,.04-.012.022-.009.012-.005.027-.016.023-.015.01-.006,0,0,.016-.014c.009-.008.018-.016.027-.025l.017-.02.007-.007,1.286-1.686A.377.377,0,0,0,34.283,39.892Z"
              transform="translate(-24.056 -30.353)" />
          </g>
        </svg>
        {{ DockLastPing }}
      </div>
    </template>
    <template v-else-if="config?.rcPlus?.id">
      <div class="flex items-center px-1 overflow-hidden" :class="RcPlusLastPingBG">
        <svg class="w-[18px] mr-2 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.519 11.901">
          <g transform="translate(0 0)">
            <path
              d="M-2.156-2.733c.012-.125.018-.251.018-.375A3.95,3.95,0,0,0-6.083-7.053h-.2a3.912,3.912,0,0,0-2.61.987,3.441,3.441,0,0,0-1.528-.359,3.439,3.439,0,0,0-3.43,3.066A3,3,0,0,0-15.755-.578a2.988,2.988,0,0,0,2.984,2.984h.569a.376.376,0,0,0,.376-.376.376.376,0,0,0-.376-.376h-.568A2.235,2.235,0,0,1-15-.578a2.241,2.241,0,0,1,1.616-2.144.376.376,0,0,0,.272-.348,2.69,2.69,0,0,1,2.7-2.6,2.694,2.694,0,0,1,1.394.391.376.376,0,0,0,.463-.059A3.171,3.171,0,0,1-6.279-6.3h.2A3.2,3.2,0,0,1-2.89-3.108a3.192,3.192,0,0,1-.035.469.376.376,0,0,0,.131.345A2.227,2.227,0,0,1-1.988-.578,2.235,2.235,0,0,1-4.22,1.654h-.569a.376.376,0,0,0-.376.376.376.376,0,0,0,.376.376h.569A2.988,2.988,0,0,0-1.236-.578,2.977,2.977,0,0,0-2.156-2.733Z"
              transform="translate(15.755 7.053)" />
            <path
              d="M14.97,39.336a.376.376,0,0,0,.071-.527l-1.286-1.686-.008-.008L13.73,37.1l-.019-.019-.019-.017-.008-.008-.009-.005-.021-.014-.024-.014-.019-.01L13.588,37l-.025-.009-.023-.006-.022,0-.026,0-.026,0h-.021l-.026,0-.026,0-.022,0-.023.006L13.323,37l-.023.009-.019.01-.024.014-.022.014-.009.005-.008.008-.019.016-.019.019-.017.02-.008.008L11.87,38.809a.376.376,0,0,0,.6.456l.611-.8v3.412a.376.376,0,1,0,.752,0V38.464l.611.8a.376.376,0,0,0,.527.071Z"
              transform="translate(-7.649 -30.352)" />
            <path
              d="M34.283,39.892a.376.376,0,0,0-.527.071l-.611.8V37.352a.376.376,0,0,0-.752,0v3.412l-.611-.8a.376.376,0,1,0-.6.456l1.287,1.686.007.007.017.02c.008.009.017.017.027.025l.016.014,0,0,.01.006.023.015.027.016.012.005.022.009.04.013.014,0,.012,0a.391.391,0,0,0,.069.007h0a.391.391,0,0,0,.069-.007l.012,0,.014,0,.04-.012.022-.009.012-.005.027-.016.023-.015.01-.006,0,0,.016-.014c.009-.008.018-.016.027-.025l.017-.02.007-.007,1.286-1.686A.377.377,0,0,0,34.283,39.892Z"
              transform="translate(-24.056 -30.353)" />
          </g>
        </svg>
        {{ RcPlusLastPing }}
      </div>
    </template>
  </td>
  <td>
    <div v-html="svg"></div>
  </td>
</template>
<script>
import { ref } from 'vue';
import {
  transformDeviceTimeToText,
  colorTextLastTimeStatus,
  RcPlusColorTextLastTimeStatus
} from "@/utils/Utils.js"


export default {
  props: {
    config: Object,
    cheack: Object,
  },

  setup() {
    return {
      svg: ref(""),
    }
  },

  mounted() {
    if (this.config?.dock?.id) {
      this.DockCheack();
    }
    else if (this.config?.rcPlus?.id) {
      this.RcPlusCheack();
    }
  },

  computed: {
    DockLastPing() {
      let LastPing = this.config?.dock?.status?.LastPing != null
        ? parseInt(this.config.dock?.status.LastPing)
        : "";

      return transformDeviceTimeToText(LastPing);
    },

    DockLastPingBG() {
      let LastPing = this.config?.dock?.status?.LastPing != null
        ? parseInt(this.config.dock?.status.LastPing)
        : 9999;

      return colorTextLastTimeStatus(LastPing);
    },

    RcPlusLastPing() {
      let LastPing = this.config?.rcPlus?.status?.LastPing != null
        ? parseInt(this.config?.rcPlus?.status.LastPing)
        : "";

      return transformDeviceTimeToText(LastPing);
    },

    RcPlusLastPingBG() {
      let LastPing = this.config?.rcPlus?.status?.LastPing != null
        ? parseInt(this.config.rcPlus.status.LastPing)
        : 9999;

      return RcPlusColorTextLastTimeStatus(LastPing);
    },

  },
  methods: {
    DockCheack() {
      let LastPing = this.config?.dock?.status?.LastPing != null
        ? parseInt(this.config.dock.status.LastPing)
        : 0;

      this.svg = LastPing > ENV.DEVICE_OFFLINE
        ? this.cheack.nok
        : this.cheack.ok;
    },
    RcPlusCheack() {
      let LastPing = this.config?.rcPlus?.status?.LastPing != null
        ? parseInt(this.config.rcPlus.status.LastPing)
        : 0;

      this.svg = LastPing > ENV.DEVICE_OFFLINE
        ? this.cheack.nok
        : this.cheack.ok;
    }
  },
  watch: {
    'config.dock.status.LastPing': {
      handler(newVal, oldVal) {
        if (newVal == oldVal) return;
        this.DockCheack();
      },
      deep: true,
    },
    'config.rcPlus.status.LastPing': {
      handler(newVal, oldVal) {
        if (newVal == oldVal) return;
        this.RcPlusCheack();
      },
      deep: true,
    }
  }
}
</script>
